import PropTypes from 'prop-types';
import React from 'react';

import {AccreditationButton} from '../AccreditationButton';
import {Doubts} from '../Doubts/Doubts';
import './Faq.style.scss';

export const Faq = (props) => {
  return (
    <div className="faq" id="faq">
      <div className="faq__content">
        <h2 className="faq__title">Ainda tem dúvidas?</h2>
        <p className="faq__text">
          Fizemos um compilado de dúvidas mais frequentes, veja abaixo.
        </p>
      </div>
      <Doubts {...props} />
      <div className="accreditation-button-box-faq">
        <div className="accreditation-button-box-faq__content">
          <AccreditationButton
            {...props}
            elementType="box:button:click"
            elementContent="none:quero-me-credenciar:duvidas"
          />
        </div>
      </div>
    </div>
  );
};

Faq.propTypes = {
  buttonFunctionShowAccreditation: PropTypes.func
};
